import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { RoleEnum } from '@/api/rest/resources/types/membership';
import { RoleDescription } from '@/api/rest/resources/types/organization';
import { useIsStaffUser } from '@/hooks/useIsStaffUser';
import { useUser } from '@/lib/auth';

import { FormCardField } from './form/FormCardField';
import { FORM_FIELD_NAMES } from './form/OnboardingForm';
import { SectionHeader } from './Section';

export const OnboardingProfile = () => {
  const { t } = useTranslation();

  const user = useUser();
  const isAdmin = user.membership.role === RoleEnum.admin;
  const isStaff = useIsStaffUser();

  return (
    <Stack spacing={8}>
      <SectionHeader i18nPath='shared.onboarding.profile.description' />
      <Stack spacing={4}>
        {Object.values(RoleDescription).map((role) => (
          <FormCardField
            key={`role-description-${role}`}
            title={t(`shared.onboarding.profile.roleDescriptionOptions.${role}.title`)}
            description={t(`shared.onboarding.profile.roleDescriptionOptions.${role}.description`)}
            formField={FORM_FIELD_NAMES.PROFILE}
            formValue={role}
            disabled={!isAdmin && !isStaff}
          />
        ))}
      </Stack>
    </Stack>
  );
};
